import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { decryptData, projectDomain } from "../../resources/constants";
import { serverLink } from "../../resources/url";
import logo from "../../images/logo.png";
import { toast } from "react-toastify";
import Loader from "../common/loader/loader";
import HensardAdmissionLetter from "./hensard/hu_admission";
import HensardPGAdmissionLetter from "./hensard/pg_admission";

const AdmissionLetterLandingPage = (props) => {
    const { slug } = useParams();
    const applicationID = decryptData(slug).split("=")[1];
    const [app_det, setapp_det] = useState([]);
    const [applicant_details, setapplicant_details] = useState([]);
    const [dt__, setdata__] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showAdmissionLetter, setShowAdmissionLetter] = useState(false);

    const componentRef = useRef(null);

    useEffect(() => {
        if (slug === "" || applicationID === "") {
            window.location.href = "https://hensarduniversity.edu.ng/";
            return;
        }
        getAdmissionLetter(applicationID);
    }, []);

    const getAdmissionLetter = async (app_id) => {
        toast.info("Downloading admission letter, please wait...");
        setLoading(true);
        try {
            const response = await axios.get(`${serverLink}registration/admissions/application_details/${app_id}`);
            if (response.data.length > 0) {
                const results = response.data[0];
                const dt = {
                    CourseCode: results.app_det.CourseCode,
                    AdmissionLevel: results.app_det.DecisionLevel,
                    AdmissionSemester: results.app_det.DecisionSemester,
                };
                const res = await axios.post(`${serverLink}registration/admissions/tuition-fee`, dt);
                if (res.data.length > 0) {
                    setdata__([{ admission: results, tuition: res.data }]);
                    setapp_det(results.app_det);
                    setapplicant_details(results.applicant_details);
                } else {
                    window.location.href = "https://hensarduniversity.edu.ng/";
                }
            } else {
                window.location.href = "https://hensarduniversity.edu.ng/";
            }
        } catch (error) {
            toast.error("Network error, please try again");
        } finally {
            setLoading(false);
        }
    };

    const printNow = () => {
        if (componentRef.current) {
            const printContent = componentRef.current.innerHTML;
            const originalContent = document.body.innerHTML;

            document.body.innerHTML = printContent; // Show only the Admission content
            window.print();
            document.body.innerHTML = originalContent; // Restore the original page
            window.location.reload(); // Reload to fix any missing functionality
        }
    }
    const getRegistrationForm = () => {
        // window.open(RegistrationForm, '_blank');
    }
    // const printAdmission = () => {
    //     setShowAdmissionLetter(true);
    //     setTimeout(() => {
    //         printNow();
    //         setShowAdmissionLetter(false);
    //         window.sessionStorage.removeItem("reload");
    //     }, 100);
    // };

    const printAdmission = () => {
        const reloadFlag = window.sessionStorage.getItem("reload");
        if (reloadFlag === "1") {
            setShowAdmissionLetter(true);
            setTimeout(() => {
                printNow();
                setShowAdmissionLetter(false);
                window.sessionStorage.removeItem("reload");
            }, 100);
        } else {
            window.sessionStorage.setItem("reload", "1");
            window.location.reload();
        }
    };

    return dt__.length === 0 ? (
        <Loader />
    ) : (
        <div className="pcoded-inner-content">
            <div className="main-body">
                <div className="page-wrapper">
                    <div className="page-body">
                        <div className="row">
                            <div className="col-sm-10">
                                <div className="row justify-content-md-center text-center mb-3">
                                    <div className="col-md-10">
                                        <img src={logo} width={"100px"} alt="Logo" />
                                        <h1>Congratulations</h1>
                                        <h6>Download your admission documents</h6>
                                        <a href="https://hensarduniversity.edu.ng/" target={"_blank"} className="btn btn-sm btn-primary mt-1">Visit our website</a>
                                    </div>
                                </div>
                                <div className="container">
                                    {/* Registration Guidelines Section */}
                                    <div className="card shadow-lg border-0 rounded-4 p-4">
                                        <div className="row align-items-center">
                                            {/* Steps List */}
                                            <div className="col-md-8">
                                                <h4 className="fw-bold text-primary">Registration Guidelines</h4>
                                                <p className="text-muted">Follow these steps to register:</p>
                                                <ul className="list-group list-group-flush ps-3">
                                                    <li className="list-group-item border-0">
                                                        <strong>1.</strong> Download Admission Letter and other supporting documents.
                                                    </li>
                                                    <li className="list-group-item border-0">
                                                        <strong>2.</strong> Visit the
                                                        <a
                                                            href="https://portal.hensarduniversity.edu.ng/payment/"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-decoration-none text-primary fw-bold ms-1"
                                                        >
                                                            Payment Portal
                                                        </a>.
                                                    </li>
                                                    <li className="list-group-item border-0">
                                                        <strong>3.</strong> Login with Email: <span className="fw-bold">{applicant_details[0]?.EmailAddress}</span> and Application ID: <span className="fw-bold">{app_det?.EntryID}</span>.
                                                    </li>
                                                    <li className="list-group-item border-0">
                                                        <strong>4.</strong> Complete document verification.
                                                    </li>
                                                </ul>
                                            </div>

                                            {/* Button Section */}
                                            <div className="col-md-4 text-center">
                                                <div className="card shadow-sm border-0 rounded-4 p-3">
                                                    <h5 className="fw-bold">Admission Letter</h5>
                                                    <button
                                                        id="printPageButton"
                                                        onClick={printAdmission}
                                                        className="btn btn-primary w-100 fw-bold"
                                                    >
                                                        Download
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {showAdmissionLetter && <>
                                        {
                                            app_det.ApplicationType === "pg" ?
                                                <div ref={componentRef}>
                                                    <HensardPGAdmissionLetter data={dt__} ref={componentRef}/>
                                                </div>
                                                :
                                            <div ref={componentRef}>
                                                <HensardAdmissionLetter data={dt__} ref={componentRef}/>
                                            </div>
                                        }

</>}


                                {/*}*/}
                                {/*{*/}
                                {/*    showUndertaking && <AdmissionUnderTaking componentRef={componentRef_2} data={dt__} />*/}
                                {/*}*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdmissionLetterLandingPage;
